import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FaMinus, FaPlus } from 'react-icons/fa';

import { TextField } from 'Shared/form/TextField';
import withFormikFields, { fieldHelpersPropType } from 'Shared/form/withFormikFields';
import { otherMedicationsPropType } from 'Shared/types';
import CommonPatientFieldWrapper from './CommonPatientFieldWrapper';
import OtherMedicationTypeaheadField from './OtherMedicationTypeaheadField';
import SectionTitleStyle from './SectionTitleStyle';

const OtherMedicationsFormStyle = styled.div`
    & .react-select {
        min-height: auto;

        .react-select__control {
            min-height: auto;
        }
    }
`;

const OtherMedicationsForm = ({
    fieldValues: { otherMedication: otherMedications },
    fieldHelpers: {
        otherMedication: { setValue },
    },
}) => {
    return (
        <CommonPatientFieldWrapper fieldName="otherText">
            {() => (
                <OtherMedicationsFormStyle>
                    <SectionTitleStyle>
                        <h2>Other Medications</h2>
                    </SectionTitleStyle>

                    {otherMedications.map((otherMedication, index) => (
                        <div key={otherMedication.id || `index-${index}`}>
                            <Row>
                                <CommonPatientFieldWrapper fieldName="otherText">
                                    {(commonProps) => (
                                        <Col md={6}>
                                            <OtherMedicationTypeaheadField
                                                {...commonProps}
                                                fieldName={`otherMedication[${index}].text`}
                                            />
                                        </Col>
                                    )}
                                </CommonPatientFieldWrapper>

                                <CommonPatientFieldWrapper fieldName="otherRouteOfAdministration">
                                    {(commonProps) => (
                                        <Col md={6}>
                                            <TextField
                                                {...commonProps}
                                                fieldName={`otherMedication[${index}].routeOfAdmin`}
                                                label="Route of Administration"
                                                placeholder="Route of Administration"
                                            />
                                        </Col>
                                    )}
                                </CommonPatientFieldWrapper>
                            </Row>

                            <Row>
                                <CommonPatientFieldWrapper fieldName="otherStrength">
                                    {(commonProps) => (
                                        <Col md={6}>
                                            <TextField
                                                {...commonProps}
                                                fieldName={`otherMedication[${index}].dose`}
                                                label="Strength"
                                                placeholder="Strength"
                                            />
                                        </Col>
                                    )}
                                </CommonPatientFieldWrapper>

                                <CommonPatientFieldWrapper fieldName="otherFrequency">
                                    {(commonProps) => (
                                        <Col md={6}>
                                            <TextField
                                                {...commonProps}
                                                fieldName={`otherMedication[${index}].frequency`}
                                                label="Frequency"
                                                placeholder="Frequency"
                                                addonButton={
                                                    <Button
                                                        variant="outline-secondary"
                                                        onClick={() => {
                                                            const newOtherMedications = [...otherMedications];
                                                            newOtherMedications.splice(index, 1);
                                                            setValue(newOtherMedications);
                                                        }}
                                                        aria-label="Remove Other Medication"
                                                    >
                                                        <FaMinus />
                                                    </Button>
                                                }
                                            />
                                        </Col>
                                    )}
                                </CommonPatientFieldWrapper>
                            </Row>
                        </div>
                    ))}

                    <Button
                        variant="link"
                        onClick={() => {
                            setValue([...otherMedications, {}]);
                        }}
                    >
                        <FaPlus /> Add Other Medication
                    </Button>
                </OtherMedicationsFormStyle>
            )}
        </CommonPatientFieldWrapper>
    );
};

OtherMedicationsForm.propTypes = {
    fieldValues: PropTypes.shape({
        otherMedication: otherMedicationsPropType,
    }).isRequired,
    fieldHelpers: fieldHelpersPropType.isRequired,
};

export default withFormikFields({ WrappedComponent: OtherMedicationsForm, fieldNames: ['otherMedication'] });
